import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { drawMarks, fitCanvas } from '@/utils/mirrorMarks'
import { mirrorBoard, marksVersion, mirrorMarksHidden, clearMirrorMarks } from '@/composables/useScreenMirror'


export default /*@__PURE__*/_defineComponent({
  __name: 'ScreenMirrorMarks',
  setup(__props) {

// Marcações do Espelho ao vivo na tela do AGENTE: o que o supervisor desenha (lápis, seta, texto, ponteiro) aparece
// por cima do WootDash, sem pegar clique. Trocou de página ou redimensionou a janela: as marcações somem (perderam o
// lugar) e o supervisor é avisado. O agente pode esconder pelo aviso do espelho (ScreenMirrorIndicator).
const canvasRef = ref<HTMLCanvasElement | null>(null)
const router = useRouter()
let frame = 0

function paint() {
  frame = 0
  const canvas = canvasRef.value
  if (!canvas) return
  const before = mirrorBoard.marks.size
  const animating = mirrorBoard.prune()
  // Lápis/seta venceu e sumiu: avisa quem depende da contagem (o aviso do espelho).
  if (mirrorBoard.marks.size !== before) marksVersion.value++
  const ctx = fitCanvas(canvas, window.innerWidth, window.innerHeight)
  if (ctx) drawMarks(ctx, window.innerWidth, window.innerHeight, mirrorBoard)
  // Lápis/seta esmaecendo ou ponteiro: continua animando; só texto parado não precisa.
  if (animating) frame = requestAnimationFrame(paint)
}

function schedule() {
  if (!frame) frame = requestAnimationFrame(paint)
}

watch(marksVersion, schedule)

let resizeTimer: ReturnType<typeof setTimeout> | undefined
function onResize() {
  if (resizeTimer) clearTimeout(resizeTimer)
  resizeTimer = setTimeout(() => { clearMirrorMarks(); schedule() }, 200)
}

const offRoute = router.afterEach((to, from) => {
  if (to.fullPath !== from.fullPath) clearMirrorMarks()
})

onMounted(() => {
  window.addEventListener('resize', onResize)
  schedule()
})
onUnmounted(() => {
  window.removeEventListener('resize', onResize)
  offRoute()
  if (frame) cancelAnimationFrame(frame)
  if (resizeTimer) clearTimeout(resizeTimer)
})

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("canvas", {
    ref_key: "canvasRef",
    ref: canvasRef,
    class: "smm mirror-block",
    "aria-hidden": "true"
  }, null, 512)), [
    [_vShow, !_unref(mirrorMarksHidden)]
  ])
}
}

})